import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./styles.css";

const PreguntasComponent = (props) => {
  return (
    <Fragment>
      <div
        id="preguntas-contenedor"
        className="preguntas-contenedor"
        align="center"
      >
        <div id="1" className="contenedor-tres-pregutnas"></div>
        <div id="2" className="contenedor-tres-pregutnas"></div>
        <div id="3" className="contenedor-tres-pregutnas"></div>
      </div>
    </Fragment>
  );
};

PreguntasComponent.propTypes = {
  array: PropTypes.array,
  guardarNuevoIdioma: PropTypes.bool,
};

export default PreguntasComponent;
